import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import {GlobalService} from '../../global.service';
import { MainCampaignActions } from "../main-campaign.actions";

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit {

  chooseOption:any;
  displayPortIn: boolean = true;
  displayChangePlan: boolean = true;
  displayNewLine: boolean = true;

  constructor(private store:Store<any>,private globalService:GlobalService, 
    private mainCampaignActions:MainCampaignActions) { 
      store.subscribe(store =>{
        this.chooseOption = store.mainCampaign.option;
      });
  }

  ngOnInit() {

    if (this.globalService.getSession('viewPlan').attributes.disable_new_line === 1){
        this.displayNewLine = false;
    }
    if (this.globalService.getSession('viewPlan').attributes.disable_port_in === 1){
      this.displayPortIn = false;
    }
    if (this.globalService.getSession('viewPlan').attributes.disable_change_plan === 1){
      this.displayChangePlan = false;
    }
    
    // @tam : check plan category
    // if that is broadband (3 or 4) >> only NEW option can choose
    // 1, // primary mobile
    // 2, // supplementary mobile
    // 3, // primary broadband
    // 4  // supplementary broadband
    var dataSession = this.globalService.getSession("mainApplication");
    var listPlans = this.globalService.getSession("viewPlan").attributes.plans;

    listPlans.forEach(plan => {
      if(plan.id == dataSession.planId){
        if(plan.plan_category == 3 || plan.plan_category == 4 ){			  
          this.displayPortIn = false;
          this.displayChangePlan = false;
        }
      }
    });
   			
    (<any>$)(".option-slider").on("setPosition",  function(){
      if($(window).outerWidth() < 768){
        $(".option-slider").show();
      }else{
        $(".option-slider").hide();
      }
     
    });
    $(window).on("resize" , function(){
      setTimeout(function() {
        (<any>$)(".option-slider").slick('slickGoTo', 0);
      }, 100);
    })


    let slider = (<any>$)(".option-slider").slick({
      slidesToShow: 1,
      dots: true,
      infinite: false,
      centerMode: true,
      arrows:false,
    });
  }

  onClickNextStep(){
    
  }

  onClickChooseOption(value) {
    this.store.dispatch(this.mainCampaignActions.updateOption(value));
  }
}
